<template>
  <div>
    <div class="h-30">
      <span class="form-item">{{title}}</span>
      <el-button class="fr" size="small" type="primary" @click="addRow">添加行</el-button>
    </div>
    <el-table
      :data="config.fields"
      style="width: 100%">
      <el-table-column
        prop="logic_name"
        label="条件名"
        min-width="200">
        <template scope="scope">
          <el-input v-model="scope.row.logic_name"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="field_id"
        label="关联数据表字段"
        min-width="200">
        <template scope="scope">
          <el-select v-model="scope.row.field_id" placeholder="请选择"  filterable clearable v-if="filterFieldIds && filterFieldIds.length > 0">
            <el-option v-for="item in filterFieldIds" 
              :label="item.name" 
              :value="item.field_id">
            </el-option>
          </el-select>
          <el-select v-model="scope.row.field_id" placeholder="请选择"  filterable clearable v-else>
            <el-option v-for="item in fields[modelId]" 
              :label="item.field + '(' + item.title + ')'" 
              :value="item.field_id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="logic"
        label="逻辑"
        min-width="150">
        <template scope="scope">
          <el-select v-model="scope.row.logic" placeholder="请选择" filterable>
            <el-option
              v-for="item in logicTypes"
              :key="item.type"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="值类型"
        min-width="150">
        <template scope="scope">
          <el-select v-model="scope.row.type" placeholder="请选择"  filterable clearable @change="typeChange(scope.row)">
            <el-option
              v-for="item in typeOptions"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="value"
        label="值"
        width="180">
        <template scope="scope">
          <el-input placeholder="请输入" v-model.trim="scope.row.value" v-if="scope.row.type == 10 || scope.row.type == 40"></el-input>
          <el-select v-model="scope.row.value" placeholder="请选择"  filterable clearable v-else-if="scope.row.type == 20">
            <el-option v-for="item in userFields" 
              :label="item.field + '(' + item.title + ')'" 
              :value="item.field_id"
              v-if="item.field != 'password'">
            </el-option>
          </el-select>
          <div v-else-if="scope.row.type == 30">
            <el-select v-model="scope.row.value" placeholder="请选择"  filterable clearable v-if="!simpleField">
              <el-option v-for="item in inputList" 
                :label="item.default.name + '(' + item.default.title + ')'" 
                :value="item.default.field_id">
              </el-option>
              <el-option
                label="id(主键)"
                value="id">
              </el-option>
            </el-select>
            <el-select v-model="scope.row.value" placeholder="请选择"  filterable clearable v-else>
              <el-option v-for="item in inputList" 
                :label="item.field + '(' + item.title + ')'" 
                :value="item.field_id">
              </el-option>
            </el-select>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="80">
        <template scope="scope">
          <el-button size="mini" @click.native.prevent="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="m-t-10 tx-c">
      <el-button type="primary" @click="addRow">添加一个</el-button>
    </div> -->
    <condition-check v-model="config.relation" class="m-t-10" @checkValid="checkValid"></condition-check>
  </div>
</template>
<script>
  import http from 'assets/js/http'
  import conditionCheck from '../conditionCheck'
  export default {
    props: {
      title: {
        default: '条件配置'
      },
      modelId: {
        default() {
          return 0
        }
      },
      config: {
        type: Object,
        default() {
          return {
            fields: [],
            relation: ''
          }
        }
      },
      inputList: {
        type: Array,
        default() {
          return []
        }
      },
      models: {
        type: Array,
        default() {
          return []
        }
      },
      fields: {
        type: Object,
        default() {
          return {}
        }
      },
      userFields: {
        type: Array,
        default() {
          return []
        }
      },
      simpleField: { // 为了区分inputList格式不同
        type: Boolean,
        default() {
          return false
        }
      },
      isFromPage: { // 判断调用来源从哪里，页面true 弹窗false
        type: Boolean,
        default() {
          return true
        }
      },
      filterFieldIds: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        conditionModel: {
          field_id: '',   // 关联数据库字段id
          logic: '',      // 逻辑
          logic_name: '', // 条件名
          type: 10,       // 常量类型
          value: ''       // 值
        },
        logicTypes: [
          { id: 10, name: '等于' },
          { id: 20, name: '不等于' },
          { id: 30, name: '大于' },
          { id: 40, name: '大于等于' },
          { id: 50, name: '小于' },
          { id: 60, name: '小于等于' },
          { id: 70, name: '含有' },
          { id: 80, name: '不含有' }
        ],
        typeOptions: [
          { id: 10, name: '常量' },
          { id: 20, name: '用户信息' },
          { id: 30, name: '本表字段' },
          { id: 40, name: '时间变量' },
          { id: 50, name: '空值' }
        ]
      }
    },
    methods: {
      typeChange(item) {
        item.value = ''
      },
      addRow() {
        this.config.fields.push(_.cloneDeep(this.conditionModel))
      },
      deleteRow(index) {
        this.config.fields.splice(index, 1)
      },
      async checkValid() {
        let logic_name = []
        _(this.config.fields).forEach((res) => {
          logic_name.push(res.logic_name)
        })
        let postData = {
          logic_name: logic_name,
          logic_str: this.config.relation
        }
        let res = await this.apiPost('cms/contents/checkLogicStr', postData)
        if (res.code == 200) {
          _g.toastMsg(this, 'success', '检查通过')
        } else {
          _g.dealError(this, res)
        }
      }
    },
    components: {
      conditionCheck
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// condition.vue?33013a11